<template>
    <div class="hero-image-container">
        <div class="hero-image">
            <div class="pageTitle">
                <div class="container">
                    <span class="subhead">BETTER OUTCOMES</span>
                    <hr>
                    <span class="headline">EASIER</span>
                </div>
            </div>
        </div>
        <!-- <div href="#" :v-scroll-to="scrollto" class="scroll-indicator">
            <i class="fas fa-chevron-down mx-auto"></i>
        </div> -->
    </div>
</template>
<script>
export default {
    name: "Hero",
    props: ['scrollto'],
    data() {
        return {

        }
    }
}
</script>


<style lang="scss" scoped>
    .hero-image-container {
    position: relative;

    .scroll-indicator {
        position: absolute;
        bottom: 0;
        color: #fff;
        width:100%;
        display: flex;
        font-size: 2rem;
        text-shadow: 1px 1px 20px #435664;
        padding: 10rem 0;
        @media screen and (min-width: 768px) {
            padding: 5rem 0;
        }

        .fa-chevron-down {
        transition: all 0.2s ease-in-out;

        &:hover {
            transform: scale(1.8);
            cursor: pointer;
        }
        }
    }
    }
    hr {
        width: 100%;
        margin: 0 0;
    }
    .hero-image {
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 300px;
    background-color: #000;
    background-image: url('../assets/hero.jpg');
    background-position: right;

    @media screen and (min-width: 768px) {
        background-position: center;
        height: calc(100vw * 9 / 23);
    }

    .pageTitle {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        font-size: 3rem;
        color: white;
        text-align: left;
        // padding: 15rem 0;
        .container {
            margin-left: 5rem;
            width: 22rem;
            text-align: center;
            font-weight: bold;

            @media screen and (max-width: 768px) {
                margin-left: 0rem;
            }

            .subhead {
                font-size: 1.6rem;

                @media screen and (min-width: 768px) {
                    font-size: 2rem;
                }
            }
        }

            @media screen and (min-width: 768px) {
                font-size: 5.8rem;
                // padding: 4rem 0;
            }

            // @include media-breakpoint-up(lg) {
            //   font-size: 3.6rem;
            //   padding: 9rem 0;
            // }
            @media screen and (min-width: 1200px) {
                // padding: 16.5rem 0;
            }
        }
    }
</style>
